var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('h4',{staticClass:"item_peson_num"},[_vm._v("\n    "+_vm._s(_vm.price)+_vm._s(_vm.$t('message["1524"]'))+"\n    ")]),_c('p',{staticClass:"item_contenet",domProps:{"textContent":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }